<div *ngIf="control.errors && control.touched">
  <ul style="margin-left: 15px">
    <li *ngFor="let error of control.errors | keyvalue" style="color: red">
      {{ getErrorMessage(error.key, error.value) }}
    </li>
  </ul>
</div>
